import React, { useEffect, useMemo, useState } from 'react';
import { Container } from 'reactstrap';
// import { successNofication } from '../../../../../../shared/components/Notification';
import CustomerAddressBookDetails from './components/CustomerAddressBookDetails';
import CustomerPrimaryAddressBookDetailsModal from '../AddOrUpdate/components/CustomerPrimaryAddressBookDetailsModal';
import PndRestApi from 'src/utils/pnd/PndRestApi';
import { LinearProgress, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';

import { showNotification } from 'src/shared/components/Notification';
import SnackbarContent from '@mui/material/SnackbarContent';
import { Redirect } from 'react-router-dom';
import { ERROR_MESSAGES } from 'src/utils/pnd/PndConstants';
const CustomerAddressBookDetailsIndex = () => {
  useEffect(() => {
    getAllMerchantCustomerAddressBook();

  }, [])

  const [reactTableData, setReactTableData] = useState([]);
  const [temp, setTempData] = useState("");
  const [viewDetailPopup, setViewDetailPopup] = useState(false);
  const [isTitle, setTitle] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isNoRecordFound, setNoRecordFound] = useState(false);
  const [isRedirect, setIsRedirect] = useState(false);
  const getAllMerchantCustomerAddressBook = async () => {
    try {
      setLoading(true);
      const response = await PndRestApi.GetAllMerchantCustomerAddressBook();
      if (response.status === 200 && response.data.status === 200) {
        const filteredData = response.data.data.filter(item => item.status === 1);
        setReactTableData({ tableHeaderData: columns, tableRowsData: filteredData});
      } else if (response?.data?.status && response?.data?.status === 204) {
        setNoRecordFound(true);
          }
      else {
        showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: ${response.data.status}`,
          `Message:${response.data.message}`,
        );
        return;
      }

    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
          "theme-light",
          "ltr",
          `SuccessCode: 500`,
          ERROR_MESSAGES.tryCatchError,
      );
    } finally {
      setLoading(false);
    }
  };



  const columns = useMemo(
    () => [
      {
        Header: '#',
        accessor: (row, i) => i + 1, // Or just use Cell below for more control
        disableGlobalFilter: true,
        disableSortBy: true,
        width: 15,
        Cell: ({ row }) => row.index + 1, // <-- This sets the serial number based on row index
      },
      {
        Header: 'Customer Name',
        accessor: 'customerName',
        disableGlobalFilter: false,
      },
      {
        Header: 'Customer Code',
        accessor: 'merchantCustomerCode',
        disableGlobalFilter: true,
      
      },
      // {
      //   Header: 'Telephone No.',
      //   accessor: 'telephoneNo',
      //   disableGlobalFilter: false,
      //   width: 25,
      // },
      {
        Header: 'Mobile No.',
        accessor: 'mobileNo',
        disableGlobalFilter: false,
      },

      // {
      //   Header: 'PO BOX',
      //   accessor: 'poBoxNo',
      //   disableGlobalFilter: true,
      // },
      // {
      //   Header: 'Contact Name',
      //   accessor: 'contactName',
      //   disableGlobalFilter: false,
      // },
      {
        Header: 'Address Type',
        accessor: 'addressType',
        disableGlobalFilter: false,
      
        Cell: ({ row }) =>
          row.original.addressType == 1 ? (
            <h6>
              <span className="badge bg-success">Primary</span>
            </h6>
          ) : (
            <h6>
              <span className="badge bg-warning">Secondary</span>
            </h6>
          )
      },
      
      {
        Header: 'Address',
        accessor: 'address',
        disableGlobalFilter: false,
        // width: 250,
      },
   

      {
        Header: 'Action',
        accessor: 'edit',
        disableSortBy: true,
        // width: 20,
        Cell: row => (
         
            <div className="icon-style" style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start"}}>
              <Tooltip title="Click here to Edit details">
                <EditIcon style={{ cursor: "pointer" }} onClick={() => edit(row.row.original)} />
              </Tooltip>
            </div>
         
        ),
      },
    ],
    [],
  );
  if (isRedirect) {
    window.location.reload();
    return <Redirect to="/web_app/pnd_merchant/customer_addres_book/view" />;
}
  const edit = async (event) => {
    if (event.merchantCustomerId) {
      setTempData(event);
      setViewDetailPopup(true);
      setTitle("Edit - Customer Address Book Details")
    }
  }
  return (
    <Container>
      {(reactTableData && reactTableData != null && reactTableData.tableRowsData != null) &&
        <CustomerAddressBookDetails reactTableData={reactTableData}  />
      }
      {loading &&<LinearProgress color="primary" />}
      {isNoRecordFound && <CustomerAddressBookDetails isNoRecordFound={isNoRecordFound} />}
      {isNoRecordFound && <SnackbarContent message={"No Record Found"} />}
      {viewDetailPopup &&
        <CustomerPrimaryAddressBookDetailsModal
          modalShow={viewDetailPopup}
          setModalShow={setViewDetailPopup}
          dataInfo={temp}
          isTitle={isTitle}
          setIsRedirect={setIsRedirect}
        
        />}
    </Container>
  );
};

export default CustomerAddressBookDetailsIndex;